export default __webpack_public_path__ + "static/media/icon-eye.cd0cd2a1.svg";